module.exports = __webpack_public_path__ + "static/media/yellow-signs-mobiles-1.56a23705.jpg";